import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "categories-page" };
const _hoisted_2 = { class: "alert-message" };
const _hoisted_3 = { class: "categories-container" };
const _hoisted_4 = { class: "category-item-content" };
const _hoisted_5 = { class: "category-info" };
const _hoisted_6 = { class: "category-name" };
const _hoisted_7 = { class: "category-meta" };
const _hoisted_8 = { class: "category-order" };
const _hoisted_9 = { class: "section-header" };
const _hoisted_10 = { class: "details-grid" };
const _hoisted_11 = { class: "form-section" };
const _hoisted_12 = { class: "form-group" };
const _hoisted_13 = { class: "form-group" };
const _hoisted_14 = { class: "form-group" };
const _hoisted_15 = { class: "form-group checkbox-group" };
const _hoisted_16 = { class: "checkbox-label" };
const _hoisted_17 = { class: "form-section" };
const _hoisted_18 = { class: "form-group" };
const _hoisted_19 = { class: "form-section" };
const _hoisted_20 = { class: "form-group" };
const _hoisted_21 = { class: "form-group" };
const _hoisted_22 = { class: "form-section" };
const _hoisted_23 = { class: "image-upload-grid" };
const _hoisted_24 = { class: "upload-item" };
const _hoisted_25 = ["disabled"];
const _hoisted_26 = {
    key: 1,
    class: "preview-item"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = { class: "upload-item" };
const _hoisted_29 = ["disabled"];
const _hoisted_30 = {
    key: 1,
    class: "preview-item"
};
const _hoisted_31 = ["src"];
const _hoisted_32 = {
    key: 0,
    class: "modal-backdrop"
};
const _hoisted_33 = { class: "modal-dialog" };
const _hoisted_34 = { class: "modal-header" };
const _hoisted_35 = { class: "modal-body" };
const _hoisted_36 = { class: "modal-footer" };
const _hoisted_37 = {
    key: 1,
    class: "empty-state-section"
};
import { ref, nextTick, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import AdminHeaderActions from '@/admin/components/AdminHeaderActions.vue';
import AdminListSection from '@/admin/components/AdminListSection.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CategoriesPage',
    setup(__props) {
        const admin = useAdmin();
        const loading = ref(false);
        const categories = ref([]);
        const selectedCategory = ref(null);
        const showAlert = ref(false);
        const alertMessage = ref('');
        const alertVariant = ref('success');
        const uploadFile = ref(null);
        const uploadField = ref(null);
        const deleteConfirm = ref(false);
        const categoryDetailsSection = ref(null);
        function loadCategories() {
            admin.getCategories((data) => {
                categories.value = data;
                if (data.length > 0 && !selectedCategory.value) {
                    selectCategory(data[0]);
                }
            });
        }
        function selectCategory(category) {
            selectedCategory.value = JSON.parse(JSON.stringify(category));
            uploadFile.value = null;
            // Auto-scroll to details section on mobile
            if (window.innerWidth <= 768) {
                nextTick(() => {
                    if (categoryDetailsSection.value) {
                        categoryDetailsSection.value.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                });
            }
        }
        function newCategory() {
            selectedCategory.value = {
                buttonTitle: '',
                pageTitle: '',
                providerFilters: '',
                buttonImage: '',
                pageImage: '',
                order: 0,
                active: true
            };
            uploadFile.value = null;
        }
        function saveCategory() {
            if (!selectedCategory.value.buttonTitle) {
                showAlertMessage('Button Title is required', 'error');
                return;
            }
            loading.value = true;
            if (selectedCategory.value.id) {
                admin.updateCategory(selectedCategory.value.id, selectedCategory.value, () => {
                    showAlertMessage('Category saved successfully', 'success');
                    loading.value = false;
                }, () => {
                    showAlertMessage('Failed to save category', 'error');
                    loading.value = false;
                });
            }
            else {
                admin.createCategory(selectedCategory.value, (response) => {
                    selectedCategory.value = response;
                    showAlertMessage('Category created successfully', 'success');
                    loading.value = false;
                }, () => {
                    showAlertMessage('Failed to create category', 'error');
                    loading.value = false;
                });
            }
        }
        function showDeleteConfirm() {
            deleteConfirm.value = true;
        }
        function deleteCategory() {
            deleteConfirm.value = false;
            loading.value = true;
            admin.deleteCategory(selectedCategory.value.id, () => {
                showAlertMessage('Category deleted successfully', 'success');
                selectedCategory.value = null;
                loading.value = false;
            }, () => {
                showAlertMessage('Failed to delete category', 'error');
                loading.value = false;
            });
        }
        function refreshCategories() {
            loadCategories();
        }
        function onImageSelected(field) {
            const input = event.target;
            if (input.files && input.files[0]) {
                uploadFile.value = input.files[0];
                uploadField.value = field;
            }
        }
        function uploadImage(field) {
            if (!uploadFile.value)
                return;
            loading.value = true;
            const reader = new FileReader();
            reader.onload = (e) => {
                const base64 = e.target.result.split(',')[1];
                admin.uploadCategoryImage({
                    content: base64,
                    fileName: uploadFile.value.name
                }, (response) => {
                    if (field === 'buttonImage') {
                        selectedCategory.value.buttonImage = response.uri;
                    }
                    else if (field === 'pageImage') {
                        selectedCategory.value.pageImage = response.uri;
                    }
                    showAlertMessage('Image uploaded successfully', 'success');
                    uploadFile.value = null;
                    loading.value = false;
                }, () => {
                    showAlertMessage('Failed to upload image', 'error');
                    loading.value = false;
                });
            };
            reader.readAsDataURL(uploadFile.value);
        }
        function showAlertMessage(message, variant = 'success') {
            alertMessage.value = message;
            alertVariant.value = variant;
            showAlert.value = true;
            setTimeout(() => {
                showAlert.value = false;
            }, 4000);
        }
        onMounted(() => {
            loadCategories();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "page-header" }, [
                    _createElementVNode("h1", null, "Category Administration"),
                    _createElementVNode("p", { class: "subtitle" }, "Manage and configure voucher categories")
                ], -1)),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (showAlert.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["alert", `alert-${alertVariant.value}`])
                            }, [
                                _createElementVNode("span", _hoisted_2, _toDisplayString(alertMessage.value), 1),
                                _createElementVNode("button", {
                                    class: "alert-close",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (showAlert.value = false))
                                }, "✕")
                            ], 2))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(AdminListSection, {
                        title: "Categories",
                        items: categories.value,
                        "selected-id": selectedCategory.value?.id,
                        loading: loading.value,
                        "search-placeholder": "Search categories...",
                        "empty-message": "No categories found",
                        "search-fields": ['buttonTitle', 'pageTitle'],
                        onSelect: selectCategory,
                        onRefresh: refreshCategories
                    }, {
                        item: _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.buttonTitle), 1),
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["badge", { enabled: item.active, disabled: !item.active }])
                                        }, _toDisplayString(item.active ? 'Active' : 'Inactive'), 3)
                                    ])
                                ])
                            ])
                        ]),
                        "item-actions": _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_8, "Order: " + _toDisplayString(item.order), 1)
                        ]),
                        _: 1
                    }, 8, ["items", "selected-id", "loading"]),
                    (selectedCategory.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            ref_key: "categoryDetailsSection",
                            ref: categoryDetailsSection,
                            class: "category-details-section",
                            onMounted: _cache[14] || (_cache[14] =
                                //@ts-ignore
                                (...args) => (_ctx.scrollToDetails && _ctx.scrollToDetails(...args)))
                        }, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("h2", null, _toDisplayString(selectedCategory.value.buttonTitle || 'Category Details'), 1),
                                _createVNode(AdminHeaderActions, {
                                    loading: loading.value,
                                    "has-id": !!selectedCategory.value.id,
                                    onSave: saveCategory,
                                    onDelete: showDeleteConfirm,
                                    onNew: newCategory
                                }, null, 8, ["loading", "has-id"])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _cache[19] || (_cache[19] = _createElementVNode("h3", null, "Basic Information", -1)),
                                    _createElementVNode("div", _hoisted_12, [
                                        _cache[15] || (_cache[15] = _createElementVNode("label", null, "Button Title", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedCategory.value.buttonTitle) = $event)),
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedCategory.value.buttonTitle]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_13, [
                                        _cache[16] || (_cache[16] = _createElementVNode("label", null, "Page Title", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedCategory.value.pageTitle) = $event)),
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedCategory.value.pageTitle]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                        _cache[17] || (_cache[17] = _createElementVNode("label", null, "Order", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((selectedCategory.value.order) = $event)),
                                            class: "form-input"
                                        }, null, 512), [
                                            [
                                                _vModelText,
                                                selectedCategory.value.order,
                                                void 0,
                                                { number: true }
                                            ]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("label", _hoisted_16, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((selectedCategory.value.active) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, selectedCategory.value.active]
                                            ]),
                                            _cache[18] || (_cache[18] = _createTextVNode(" Active "))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                    _cache[21] || (_cache[21] = _createElementVNode("h3", null, "Configuration", -1)),
                                    _createElementVNode("div", _hoisted_18, [
                                        _cache[20] || (_cache[20] = _createElementVNode("label", null, "Provider Filters", -1)),
                                        _withDirectives(_createElementVNode("textarea", {
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((selectedCategory.value.providerFilters) = $event)),
                                            class: "form-textarea",
                                            placeholder: "Enter provider filters..."
                                        }, null, 512), [
                                            [_vModelText, selectedCategory.value.providerFilters]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                    _cache[24] || (_cache[24] = _createElementVNode("h3", null, "Images", -1)),
                                    _createElementVNode("div", _hoisted_20, [
                                        _cache[22] || (_cache[22] = _createElementVNode("label", null, "Button Image URL", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((selectedCategory.value.buttonImage) = $event)),
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedCategory.value.buttonImage]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                        _cache[23] || (_cache[23] = _createElementVNode("label", null, "Page Image URL", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((selectedCategory.value.pageImage) = $event)),
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedCategory.value.pageImage]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                    _cache[27] || (_cache[27] = _createElementVNode("h3", null, "Image Upload", -1)),
                                    _createElementVNode("div", _hoisted_23, [
                                        _createElementVNode("div", _hoisted_24, [
                                            _cache[25] || (_cache[25] = _createElementVNode("label", null, "Button Image", -1)),
                                            _createElementVNode("input", {
                                                type: "file",
                                                onChange: _cache[8] || (_cache[8] = ($event) => (onImageSelected('button'))),
                                                class: "file-input"
                                            }, null, 32),
                                            (uploadFile.value)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    class: "action-btn secondary",
                                                    onClick: _cache[9] || (_cache[9] = ($event) => (uploadImage('buttonImage'))),
                                                    disabled: !uploadFile.value
                                                }, " 📤 Upload ", 8, _hoisted_25))
                                                : _createCommentVNode("", true),
                                            (selectedCategory.value.buttonImage)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                    _createElementVNode("img", {
                                                        src: selectedCategory.value.buttonImage,
                                                        alt: "Button Image",
                                                        class: "preview-image"
                                                    }, null, 8, _hoisted_27)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_28, [
                                            _cache[26] || (_cache[26] = _createElementVNode("label", null, "Page Image", -1)),
                                            _createElementVNode("input", {
                                                type: "file",
                                                onChange: _cache[10] || (_cache[10] = ($event) => (onImageSelected('page'))),
                                                class: "file-input"
                                            }, null, 32),
                                            (uploadFile.value)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    class: "action-btn secondary",
                                                    onClick: _cache[11] || (_cache[11] = ($event) => (uploadImage('pageImage'))),
                                                    disabled: !uploadFile.value
                                                }, " 📤 Upload ", 8, _hoisted_29))
                                                : _createCommentVNode("", true),
                                            (selectedCategory.value.pageImage)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                    _createElementVNode("img", {
                                                        src: selectedCategory.value.pageImage,
                                                        alt: "Page Image",
                                                        class: "preview-image"
                                                    }, null, 8, _hoisted_31)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])
                            ]),
                            _createVNode(_Transition, { name: "fade" }, {
                                default: _withCtx(() => [
                                    (deleteConfirm.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                            _createElementVNode("div", _hoisted_33, [
                                                _createElementVNode("div", _hoisted_34, [
                                                    _cache[28] || (_cache[28] = _createElementVNode("h3", null, "Confirm Delete", -1)),
                                                    _createElementVNode("button", {
                                                        class: "modal-close",
                                                        onClick: _cache[12] || (_cache[12] = ($event) => (deleteConfirm.value = false))
                                                    }, "✕")
                                                ]),
                                                _createElementVNode("div", _hoisted_35, [
                                                    _createElementVNode("p", null, [
                                                        _cache[29] || (_cache[29] = _createTextVNode("Are you sure you want to delete ")),
                                                        _createElementVNode("strong", null, _toDisplayString(selectedCategory.value.buttonTitle), 1),
                                                        _cache[30] || (_cache[30] = _createTextVNode("?"))
                                                    ]),
                                                    _cache[31] || (_cache[31] = _createElementVNode("p", null, "This action cannot be undone.", -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_36, [
                                                    _createElementVNode("button", {
                                                        class: "action-btn secondary",
                                                        onClick: _cache[13] || (_cache[13] = ($event) => (deleteConfirm.value = false))
                                                    }, "Cancel"),
                                                    _createElementVNode("button", {
                                                        class: "action-btn danger",
                                                        onClick: deleteCategory
                                                    }, "Delete")
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ], 544))
                        : (_openBlock(), _createElementBlock("div", _hoisted_37, _cache[32] || (_cache[32] = [
                            _createElementVNode("p", null, "Select a category to view details", -1)
                        ])))
                ])
            ]));
        };
    }
});
